import { useState } from "react";
import { useDispatch } from "react-redux";

import { deleteAssignedWorksheetList } from "../../assignedWorksheetListSlice";
import { deleteAssignmentList } from "../../assignmentListSlice";

import { Button } from "../../../../components/Button";

// `onSendNotice` 를 주면 삭제하기 옆에 알림톡 발송 버튼이 생긴다. 과제 미완수자
// 명단에서만 쓰고, 다른 목록에서는 이 prop 을 안 줘서 버튼이 안 나온다.
const DeleteWorksheetModal = ({
  worksheets,
  setSelectedWorksheets,
  type,
  onDeleted,
  onSendNotice,
}) => {
  const dispatch = useDispatch();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleSendNoticeClick = () => {
    // disabled 로 막지 않는다. disabled 인 버튼은 onClick 이 아예 안 걸려서
    // 왜 안 되는지 알려줄 수가 없다. 두 번 눌리는 것은 여기서 막는다.
    if (isSending) {
      return;
    }
    if (
      !window.confirm(
        `선택한 ${worksheets.length}명에게 미완료 안내 알림톡을 보냅니다.`
      )
    ) {
      return;
    }

    setIsSending(true);
    Promise.resolve(onSendNotice(worksheets)).finally(() => setIsSending(false));
  };

  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (type === "assigned") {
      await dispatch(
        deleteAssignedWorksheetList({
          worksheetIds: worksheets.map((worksheet) => worksheet.id),
        })
      );
    } else {
      // For retry assignments, use the same deletion as regular assignments
      await dispatch(
        deleteAssignmentList({
          assignmentIds: worksheets.map((worksheet) => worksheet.id),
        })
      );
    }
    setIsDeleteModalOpen(false);
    setSelectedWorksheets([]);
    if (typeof onDeleted === "function") onDeleted();
  };

  // [추가] 삭제 모달 닫기
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const styles = {
    overlayStyle: {
      position: "fixed",
      bottom: 0,
      left: 0,
      width: "100%",
      backgroundColor: "#2D2D2D",
      color: "#fff",
      padding: "20px",
      textAlign: "center",
      zIndex: 9999,
    },
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "#000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      width: "300px",
      maxWidth: "90%",
    },
    modalHeader: {
      textAlign: "center",
      fontSize: "16px",
      marginBottom: "40px",
    },
    modalBody: {
      marginBottom: "40px",
      lineHeight: "1.0",
    },
    modalFooter: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    dangerButton: {
      backgroundColor: "#FF4444",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      width: "100%",
      cursor: "pointer",
      borderRadius: "4px",
    },
    cancelButton: {
      backgroundColor: "#EBEBEB",
      color: "#737373",
      border: "none",
      padding: "6px 12px",
      cursor: "pointer",
      width: "100%",
      borderRadius: "4px",
    },
  };

  return (
    <div style={styles.overlayStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "70%",
          margin: "0 auto",
        }}
      >
        <strong>{worksheets.length}개 선택됨</strong>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {onSendNotice && (
            <Button
              backgroundColor="#FFFFFF"
              color="#00A396"
              border="1px solid #EBEBEB"
              fontSize="16px"
              padding="10px 35px"
              onClick={handleSendNoticeClick}
            >
              {isSending ? "보내는 중…" : "알림톡 발송"}
            </Button>
          )}

          <Button
            backgroundColor="#FFFFFF"
            color="#FF4444"
            border="1px solid #EBEBEB"
            fontSize="16px"
            padding="10px 35px"
            onClick={() => handleDeleteClick()}
          >
            삭제하기
          </Button>

          {isDeleteModalOpen && (
            <div style={styles.modalOverlay} onClick={closeDeleteModal}>
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={styles.modalHeader}>과제 삭제</div>
                <div style={styles.modalBody}>
                  <strong style={{ textAlign: "center" }}>
                    {worksheets[0].title}를 포함한 {worksheets.length}개의
                  </strong>
                  <p>
                    <strong style={{ textAlign: "center" }}>
                      과제를 정말 삭제하시겠습니까?
                    </strong>
                  </p>
                </div>
                <div style={styles.modalFooter}>
                  <button style={styles.dangerButton} onClick={confirmDelete}>
                    네
                  </button>
                  <button
                    style={styles.cancelButton}
                    onClick={closeDeleteModal}
                  >
                    아니오
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteWorksheetModal;
